// extracted by mini-css-extract-plugin
export default {"page":"Sandbox_page__gS83D","grid":"Sandbox_grid__sqM9j"};